import React, {useEffect, useState} from "react"
import Image from '../ResuableImageWrapper';
import parse from 'html-react-parser';
import QuoteMark from '../../../assets/quote_lrg.inline.svg';
import VisibilitySensor from 'react-visibility-sensor';
import "../../../sass/components/reuseable_components/_case_testimonial.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CaseStudyQuotationSlider = (data, {  isInView }) => {

  
  let classList = [
    'case_testimonial',
    // 'is_inview'
  ]; 

  const removeBottomMargin = data.removeBottomMargin;

  if(removeBottomMargin === true){
    classList.push('no-margin');
  }

  const [theSwiper, setTheSwiper] = useState()
  const [isInview, setIsInview] = useState(false);

  function inviewOnChange (isVisible) {
    setIsInview(isVisible)
  }

  const settings = {
    dots: true,
    infinite: true,
    fade:true,
    autoplay:false,
    speed: 500,
    interval:0,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover:false,
    autoplaySpeed:0,
    draggable:false,
    adaptiveHeight: true,
    // beforeChange: (oldIndex, newIndex) => {
    //   if(isInview === true){
    //     // clearProps()
    //   }
    //   // console.log(oldIndex, newIndex)
    // }
  };

  useEffect(() => {
    if(isInview === true){
      const slideLength = 2;
      let currentSlide = 1;
      
      const interval = setInterval(() => {
          if(currentSlide <= slideLength){
            theSwiper.slickGoTo(currentSlide)
            currentSlide++;
          }else{
            theSwiper.slickGoTo(0)
            currentSlide = 0
          }         
      }, 9000);
      return () => clearInterval(interval);
    }
  }, [isInview]);
  
  return (
    <VisibilitySensor partialVisibility={true} offset={{bottom:120}} active={!isInview}  onChange={inviewOnChange}>
      {({isVisible}) =>
        <section className={`${classList.join(" ")} ${isInview ? 'is_inview' : ''}`}>
          <div className="wrapper-900 clearfix">
            <div className="orange_quote"><span>&ldquo;</span></div>
            <Slider {...settings} ref={slider => (setTheSwiper(slider))}>
              {
                data.quotations.map(slide => {
                  return(
                    <>
                      <div className="label">{slide.labelHeading}</div>
                      <div className="testimonial">{parse(slide.quotation)}</div>
                      <div className="quote">
                        <Image
                        image={slide?.personPhoto?.localFile?.childImageSharp?.fluid}
                        alt={slide?.personPhoto?.altText}
                        />
                        {slide.quotationCompany &&
                        slide.quotationCompanyLink &&
                        slide.quotationPerson &&
                        slide.quotationPosition ?
                          <div className="person">{`${slide.quotationPerson} | ${slide.quotationPosition} | `}<a className="" href={slide.quotationCompanyLink} target="_blank" rel="noreferrer noopener">{slide.quotationCompany}</a></div>
                        : <div className="person">{slide.personPositionCompany}</div>
                        }
                      </div>
                    </>
                  )
                })
              }
            
            </Slider>
           
            <div className="large_quote">
              <QuoteMark />
            </div>
            <div className="horiz-line"><div className="line"></div></div>
          </div>
        </section>
      }
    </VisibilitySensor>
  )
}

export default CaseStudyQuotationSlider

